import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getUsers, syncUsers, toggleUserStatus } from "../redux/userSpeaker/userSpeakerSlice";
import { toast } from "react-toastify";
import { truncateText } from "../helper/helper";
import useDebounce from "../hook/useDebounce";
import { getRoles } from "../redux/role/roleSlice";
import { getEventLocations } from "../redux/eventLocation/eventLocationSlice";
import Dropdown from "react-bootstrap/Dropdown";
import BulkUserUpload from "./Users/BulkUserUploadComponent";
import { useLocationFilter } from "../context/LocationContext";
import Avatar from "./Avtar/Avatar";
import PaginationHelper from "../helper/PaginationHelper";
import ExportUsersComponent from "./Users/ExportUsersComponent";

const UsersListLayer = () => {

  const dispatch = useDispatch();
  const { selectedLocation } = useLocationFilter();

  const {
    users = [],
    total = 0,
    totalPages = 1,
    loading,
    syncLoading
  } = useSelector((state) => state.speaker);
  const { roles = [] } = useSelector((state) => state.role);
  const { locations = [] } = useSelector((state) => state.eventLocation);

  const [roleFilter, setRoleFilter] = useState("");
  const [search, setSearch] = useState("");
  const [entries, setEntries] = useState(50);
  const [currentPage, setCurrentPage] = useState(1);
  const debouncedSearch = useDebounce(search, 1000);
  const [confirmUser, setConfirmUser] = useState(null);
  const [toggling, setToggling] = useState(false);

  const queryParams = useMemo(() => ({
    page: currentPage,
    limit: entries,
    search: debouncedSearch?.trim() || "",
    roleId: roleFilter || "",
    locationId: selectedLocation?.value || ""
  }), [currentPage, entries, debouncedSearch, roleFilter, selectedLocation]);

  useEffect(() => {
    dispatch(getUsers(queryParams));
  }, [dispatch, queryParams]);

  return (
    <div className="card h-100 p-0 radius-12">

      <div className="card-header border-bottom bg-base py-16 px-24 d-flex justify-content-between align-items-center flex-wrap gap-3">

        <div className="d-flex align-items-center flex-wrap gap-3">

          <span className="text-md fw-medium text-secondary-light">
            Show
          </span>

          <select
            className="form-select form-select-sm w-auto h-40-px"
            value={entries}
            onChange={(e) => {
              setEntries(Number(e.target.value));
              setCurrentPage(1);
            }}
          >
            {[50, 100, 150, 200].map((v) => (
              <option key={v} value={v}>{v}</option>
            ))}
          </select>

          <div className="position-relative">
            <input
              type="text"
              className="form-control form-control-sm h-40-px pe-32"
              style={{ width: 180 }}
              placeholder="Search"
              value={search}
              onChange={(e) => {
                setSearch(e.target.value);
                setCurrentPage(1);
              }}
            />
            <Icon
              icon="ion:search-outline"
              className="position-absolute top-50 translate-middle-y end-0 me-2 text-secondary"
            />
          </div>

          <select
            className="form-select form-select-sm w-auto h-40-px"
            value={roleFilter}
            onChange={(e) => {
              setRoleFilter(e.target.value);
              setCurrentPage(1);
            }}
            onFocus={() => {
              if (!roles.length) dispatch(getRoles());
            }}
          >
            <option value="">Select Role</option>
            {roles.map((role) => (
              <option key={role.id} value={role.id}>
                {role.name}
              </option>
            ))}
          </select>

        </div>

        <div className="d-flex align-items-center gap-2">
          <ExportUsersComponent
            locationId={selectedLocation?.value || ""}
            roleId={roleFilter || ""}
          />

          <BulkUserUpload refreshUsers={() => dispatch(getUsers(queryParams))} />
          <Link
            to="/add-user"
            className="btn btn-primary btn-sm d-flex align-items-center gap-2"
          >
            <Icon icon="ic:baseline-plus" />
            Add User
          </Link>

          <Dropdown
            align="end"
            onToggle={(isOpen) => {
              if (isOpen && !locations.length) {
                dispatch(getEventLocations());
              }
            }}
          >
            <Dropdown.Toggle
              variant="info"
              size="sm"
              className="d-flex align-items-center"
            >
              <Icon icon="mdi:refresh" />
              {syncLoading ? "Syncing..." : "Sync"}
            </Dropdown.Toggle>

            <Dropdown.Menu
              style={{
                width: 260,
                maxHeight: 280,
                overflowY: "auto",
                borderRadius: "10px",
                fontSize: "12px"
              }}
              className="shadow-sm"
            >

              <Dropdown.Item
                className="fw-semibold text-primary"
              // onClick={async () => {
              //   try {
              //     await dispatch(syncUsers()).unwrap();
              //     toast.success("All users synced");
              //     dispatch(getUsers(queryParams));
              //   } catch (err) {
              //     toast.error(err?.message || "Sync failed");
              //   }
              // }}
              >
                Select Locaion
              </Dropdown.Item>

              <Dropdown.Divider />

              {locations.length === 0 ? (
                <Dropdown.Item disabled>Loading...</Dropdown.Item>
              ) : (
                locations.map((loc) => (
                  <Dropdown.Item
                    key={loc.id}
                    className="d-flex align-items-center"
                    onClick={async () => {
                      try {
                        await dispatch(syncUsers(loc.id)).unwrap();
                        toast.success(`Synced: ${loc.name}`);
                        dispatch(getUsers(queryParams));
                      } catch (err) {
                        if (err?.errors && Array.isArray(err.errors)) {
                          err.errors.forEach((e) => {
                            toast.error(`${e.message} (${e.value})`);
                          });
                        } else {
                          toast.error(err?.message || "Something went wrong");
                        }
                      }
                    }}
                  >
                    {/* <Icon icon="mdi:map-marker-outline" /> */}
                    <span title={loc.name}>
                      {truncateText(loc.name, 28)}
                    </span>
                  </Dropdown.Item>
                ))
              )}

            </Dropdown.Menu>
          </Dropdown>

        </div>
      </div>

      <div className="card-body p-12">

        <div className="table-responsive scroll-sm">

          <table className="table bordered-table sm-table mb-0">

            <thead>

              <tr>

                <th>
                  <div className="d-flex align-items-center gap-10">
                    {/* <div className="form-check style-check">
                      <input
                        className="form-check-input radius-4 border"
                        type="checkbox"
                      />
                    </div> */}
                    #
                  </div>
                </th>
                <th>Badge Id</th>
                <th>Name</th>
                <th>Email</th>
                <th>Code</th>
                <th>Phone</th>
                <th>Role</th>
                <th>Company</th>
                <th>Designation</th>
                <th>Status</th>
                <th>Action</th>
              </tr>

            </thead>

            <tbody>

              {users?.map((user, index) => (

                <tr key={user.id}>

                  <td>
                    <div className="">
                      {/* <div className="form-check style-check">
                        <input
                          className="form-check-input radius-4 border"
                          type="checkbox"
                        />
                      </div> */}

                      {(currentPage - 1) * entries + index + 1}

                    </div>
                  </td>
                  <td>
                    <span className="text-md text-secondary-light">
                      {user.badgeId ?? "-"}
                    </span>
                  </td>

                  <td>
                    <div className="d-flex align-items-center gap-2">

                      <Avatar
                        name={user.fullName}
                        image={user.profilePicture}
                        uniqueKey={user.id}
                        size={28}
                      />

                      <span>
                        {truncateText(user.fullName, 10)}
                      </span>

                    </div>
                  </td>

                  <td>
                    <span className="text-md text-secondary-light">
                      {truncateText(user.email, 20)}
                    </span>
                  </td>

                  <td>
                    <span className="text-md text-secondary-light">
                      {user.countryCode}
                    </span>
                  </td>

                  <td>
                    <span className="text-md text-secondary-light">
                      {truncateText(user.phone, 20)}
                    </span>
                  </td>

                  <td>
                    <span className="text-md text-secondary-light">
                      {truncateText(user?.Role?.name, 20)}
                    </span>
                  </td>

                  <td className="text-md text-secondary-light">
                    <span className="text-md text-secondary-light">
                      {truncateText(user?.Company?.name, 20)}
                    </span>

                  </td>
                  <td className="text-md text-secondary-light">
                    <span className="text-md text-secondary-light">
                      {truncateText(user?.designation, 20)}
                    </span>

                  </td>
                  <td>
                    <div className="d-flex flex-column align-items-center gap-4">

                      {/* <span
                        className={`px-10 py-2 radius-20 text-xs fw-semibold ${user.status
                          ? "bg-success-100 text-success-600"
                          : "bg-danger-100 text-danger-600"
                          }`}
                      >
                        {user.status ? "Active" : "Disabled"}
                      </span> */}

                      <label className="switch-toggle">
                        <input
                          type="checkbox"
                          checked={user.status}
                          onChange={() => setConfirmUser(user)}
                        />
                        <span className="slider" />
                      </label>

                    </div>
                  </td>

                  <td className="text-center">

                    <div className="d-flex align-items-center gap-10 justify-content-center">

                      <Link
                        to={`/view-profile/${user.id}`}
                        className="bg-info-focus bg-hover-info-200 text-info-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                      >
                        <Icon icon="majesticons:eye-line" />
                      </Link>

                      <Link
                        to={`/view-profile/${user.id}`}
                        className="bg-success-focus text-success-600 bg-hover-success-200 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                      >
                        <Icon icon="lucide:edit" />
                      </Link>

                    </div>

                  </td>

                </tr>

              ))}

            </tbody>

          </table>

        </div>
        {confirmUser && (
          <div className="modal fade show d-block">
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content radius-12 shadow-lg">

                <div className="modal-header border-0">
                  <h5 className="fw-semibold">
                    {confirmUser.status ? "Disable User" : "Activate User"}
                  </h5>
                  <button
                    className="btn-close"
                    onClick={() => setConfirmUser(null)}
                  />
                </div>

                <div className="modal-body text-center">
                  <p className="mb-2">
                    Are you sure you want to{" "}
                    <strong>
                      {confirmUser.status ? "disable" : "activate"}
                    </strong>{" "}
                    this user?
                  </p>

                  <small className="text-muted">
                    {confirmUser.status
                      ? "User will not be able to login."
                      : "User will regain access."}
                  </small>
                </div>

                <div className="modal-footer border-0 justify-content-center gap-2">

                  <button
                    className="btn btn-light"
                    onClick={() => setConfirmUser(null)}
                  >
                    Cancel
                  </button>

                  <button
                    className={`btn ${confirmUser.status ? "btn-danger" : "btn-success"
                      }`}
                    disabled={toggling}
                    onClick={async () => {
                      try {
                        setToggling(true);

                        await dispatch(toggleUserStatus(confirmUser.id)).unwrap();
                        dispatch(getUsers(queryParams));
                        toast.success(
                          confirmUser.status
                            ? "User disabled successfully"
                            : "User activated successfully"
                        );

                        setConfirmUser(null);

                      } catch (err) {
                        toast.error(
                          err?.message || "Failed to update status"
                        );
                      } finally {
                        setToggling(false);
                      }
                    }}
                  >
                    {toggling
                      ? "Processing..."
                      : confirmUser.status
                        ? "Disable"
                        : "Activate"}
                  </button>

                </div>

              </div>
            </div>
          </div>
        )}

        {/* PAGINATION */}
        <PaginationHelper
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={setCurrentPage}
          totalItems={total}
          pageSize={entries}
        />

      </div>

    </div>
  );
};

export default UsersListLayer;